import { REDUX_ACTIONS } from '../../shared/config/constants';
const initialState = {
  loading: false,
  deleting: false,
  data: [],
  units: {},
  errorMessage: '',
  loadingDelete: false,
  saved: false,
  paginatedElements: 0,
};
const hydraulicsRolloverReducer = (state = initialState, action) => {
  switch (action.type) {
    case REDUX_ACTIONS.HYDRAULICS_ROLLOVER_LIST_LOADING:
      return {
        ...state,
        loading: true,
        errorMessage: ''
      };
    case REDUX_ACTIONS.HYDRAULICS_ROLLOVER_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        data: [...action.payload.data],
        units: { ...action.payload.units },
        paginatedElements: action.payload.paginatedElements,
        permissionId: action?.payload?.permissionId ?? null,
        permissions: action?.payload?.permissions ?? state?.permissions ?? {},
        createdDetails: action?.payload?.lastUpdate
          ? {
              createdBy: action?.payload?.createdBy,
              lastUpdate: action?.payload?.lastUpdate,
              lastUpdatedBy: action?.payload?.lastUpdatedBy
            }
          : state?.createdDetails,
        errorMessage: '',
        ph_version: action.payload?.ph_version
      };
    case REDUX_ACTIONS.HYDRAULICS_ROLLOVER_LIST_ERROR:
      return {
        ...state,
        loading: false,
        errorMessage: action.payload.message,
        data: []
      };
    case REDUX_ACTIONS.HYDRAULICS_ROLLOVER_LIST_ERROR_NOTIFIED:
      return {
        ...state,
        errorMessage: '',
        data: []
      };
    case REDUX_ACTIONS.HYDRAULICS_ROLLOVER_RESET:
      return {
        ...initialState
      };
    case REDUX_ACTIONS.HYDRAULICS_ROLLOVER_SET_FALSE:
      return {
        ...state,
        loading: false,
        errorMessage: ''
      };
    default:
      return state;
  }
};
export default hydraulicsRolloverReducer;
